import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ElMessage } from 'element-plus';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import customFooter from '@/components/Footer.vue';
import customHeader from '@/components/Header.vue';
import LitigationMembersListModal from '@/components/LitigationMembersListModal.vue';
import MemberDetailsModal from '@/components/MemberDetailsModal.vue';
import { Member } from '@/Member/member.entity';
import MemberService from '@/Member/member.service';
import StatusService from '@/status.service';
import { useCapabilityStore } from '@/stores/capability';
import { useMemberStore } from '@/stores/member';
import { useMemberModalsStore } from '@/stores/member-modals.store';
import Login from '@/views/Login.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { t, locale } = useI18n();

const memberStore = useMemberStore();
const capabilityStore = useCapabilityStore();
const memberModalsStore = useMemberModalsStore();

const receivedResponse = ref(false);

const isLoggedIn = computed((): boolean => {
    return memberStore.isLoggedIn;
});

const getExistingCookies = async (): Promise<Member> => {
    const memberService = new MemberService();
    return memberService.getConnectedMember();
};

onMounted(async () => {
    document.getElementsByTagName('html')[0].setAttribute('lang', locale.value.split('-')[0]);

    try {
        const freshMember = await getExistingCookies();
        memberStore.member = freshMember;
        capabilityStore.sync();
    } catch (error) {
        const { message, response } = error as { message: string; response: { status: number } };
        if (response && response.status !== 401) {
            ElMessage.error(message || t('common.unknownError'));
        }
    }

    const statusService = new StatusService();

    const checkNewRelease = async (statusService: StatusService) => {
        const currentApiRelease = localStorage.getItem('apiRelease');
        const newStatus = await statusService.getStatus();
        if (!newStatus.apiRelease) {
            return;
        }
        const isNewRelease = !currentApiRelease || newStatus.apiRelease !== currentApiRelease;
        if (isNewRelease) {
            localStorage.setItem('apiRelease', newStatus.apiRelease);
            window.location.reload();
        }
    };

    setTimeout(() => checkNewRelease(statusService), 2000);
    setInterval(() => checkNewRelease(statusService), 10000);

    receivedResponse.value = true;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (isLoggedIn.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(customHeader),
        _createElementVNode("div", {
          id: "main",
          class: _normalizeClass(['is-flex is-flex-direction-row container is-fluid', { 'pt-6 is-height-navbar': isLoggedIn.value }])
        }, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          })
        ], 2),
        (_ctx.$route.name == 'litigation-list')
          ? (_openBlock(), _createBlock(customFooter, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(memberModalsStore).member)
          ? (_openBlock(), _createBlock(MemberDetailsModal, {
              key: 1,
              member: _unref(memberModalsStore).member,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(memberModalsStore).closeMemberDetails()))
            }, null, 8, ["member"]))
          : _createCommentVNode("", true),
        (_unref(memberModalsStore).members)
          ? (_openBlock(), _createBlock(LitigationMembersListModal, {
              key: 2,
              "litigation-name": _unref(memberModalsStore).litigationName,
              members: _unref(memberModalsStore).members,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(memberModalsStore).closeLitigationMembers()))
            }, null, 8, ["litigation-name", "members"]))
          : _createCommentVNode("", true)
      ], 64))
    : (receivedResponse.value)
      ? (_openBlock(), _createBlock(Login, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})